import { Box, Divider, InputLabel, MenuItem, FormControl, Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const SelectSection = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  width: 'calc(100% - 26px)'
});

export const SectionColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column'
});

export const SectionDivider = styled(Divider)({
  marginTop: '20px',
  marginBottom: '15px',
  width: 'calc(100% - 26px)'
});

export const TenantFormControl = styled(FormControl)({
  width: '200.5px',
  height: '40px',
  marginTop: '25px',
  marginLeft: '192.5px',
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: '#5F65F6'
    }
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: '#5F65F6'
    }
  }
});

export const StyledInputLabel = styled(InputLabel)(({ isDisabled }: { isDisabled: boolean }) => ({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '400px',
  color: isDisabled ? '#9E9E9E' : '#666666'
}));

export const StyledTenantSelect = styled(Select)({
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },
  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  },
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6'
    }
  }
});

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: 'Open Sans',
  fontStyle: 'normal',
  fontWeight: '400px',
  width: '200px'
});

export const LocationFormControl = styled(FormControl)(
  ({ isDisabled }: { isDisabled: boolean }) => ({
    width: '200.5px',
    height: '40px',
    marginTop: '25px',
    marginLeft: '225px',
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: isDisabled ? '' : '#5F65F6'
      }
    },
    '&:hover': {
      '& .MuiInputLabel-root': {
        color: isDisabled ? '' : '#5F65F6'
      }
    }
  })
);

export const StyledLocationSelect = styled(Select)(({ isDisabled }: { isDisabled: boolean }) => ({
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },

  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  },
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: isDisabled ? '' : '#5F65F6'
    }
  }
}));

export const PricelistFormControl = styled(FormControl)(
  ({ isDisabled }: { isDisabled: boolean }) => ({
    width: '200.5px',
    height: '40px',
    marginTop: '25px',
    marginLeft: '260px',
    '& .MuiInputLabel-root': {
      '&.Mui-focused': {
        color: isDisabled ? '' : '#5F65F6'
      }
    },
    '&:hover': {
      '& .MuiInputLabel-root': {
        color: isDisabled ? '' : '#5F65F6'
      }
    }
  })
);

export const StyledPricelistSelect = styled(Select)(({ isDisabled }: { isDisabled: boolean }) => ({
  '&.MuiOutlinedInput-root': {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: '400px'
  },

  maxHeight: 48 * 5,
  '&.Mui-focused': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#5F65F6',
      borderWidth: '1px'
    }
  },
  '&:hover': {
    '& .MuiInputLabel-root': {
      color: isDisabled ? '' : '#5F65F6'
    }
  }
}));

const MENU_ITEM_HEIGHT = 36;
export const SelectMenuProps = {
  PaperProps: {
    style: {
      maxHeight: MENU_ITEM_HEIGHT * 5.5
    }
  }
};
